import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./brand.css";
import App from "./App";
import { DevToolsProvider } from "./AppContext";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./partials/ErrorBoundary/ErrorBoundary";


import TagManager from 'react-gtm-module'
if (process.env.REACT_APP_RUNTIME_ENVIRONMENT === "production") {
  const tagManagerArgs = {
    gtmId: 'GTM-MZ5ZGRZ'
  }
  TagManager.initialize(tagManagerArgs)
}

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <DevToolsProvider>
        <App />
      </DevToolsProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);




reportWebVitals();
